module.exports = __webpack_public_path__ + "img/lazar.7bee4bd7.webp";